import { render } from "./MyBoard.vue?vue&type=template&id=38c7aad4"
import script from "./MyBoard.vue?vue&type=script&lang=js"
export * from "./MyBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__